import { TRANSITION_SLOW_MS } from "@frontend/styles";
import type { ChartAnimationOptions } from "@tanstack/charts";

// Same timing scale as the anime.js transitions of the other components, so a
// chart update does not feel like it belongs to another application.
export const ANIMATION_DURATION = TRANSITION_SLOW_MS;

// Marks reconcile by key, so an updated dataset tweens the surviving marks
// instead of repainting them. Resize stays instant, and the renderer skips
// the tween under prefers-reduced-motion.
export function chartAnimation(
  animate: boolean,
): ChartAnimationOptions | undefined {
  return animate
    ? { duration: ANIMATION_DURATION, easing: "ease-out" }
    : undefined;
}
